const Photo = ({
    id = '',
    feedId = '',
    feedListingId = '',
    rank = '',
    url = '',
}) => ({
    id: String(id),
    feedId: String(feedId),
    feedListingId: String(feedListingId),
    rank: String(rank),
    url: String(url),
});

export default Photo;
